<div class='fullcontainer'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Account was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Contact - {{ this.contact.firstName }} {{ this.contact.lastName }}</h1>
    <app-audit-line [data]='this.contact'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-contact-form [contact]='this.contact'></app-contact-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/contacts'>Cancel</button>
    </form>
  </div>
</div>
